import React from "react";
import { CardUi } from "../../ui/CardUi";
import { Col, Row } from "antd";
import { AccesoUsuarioTree } from "./AccesosUsuarioTree";

export const AccesosUsuarioDiv = ({ treeData }) => {
  return (
    <CardUi type="inner" title="Accesos usuario" size="small">
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <AccesoUsuarioTree treeData={treeData} />
        </Col>
      </Row>
    </CardUi>
  );
};
